import React from 'react';
import EditorActionButton, { FileUploadActionButton } from './button';
import ExpandableEditorActionButton from './expandable-button/react';

import './index.scss';

function EditorActions(props) {

  function renderEditorActionButton(action, groupClickHandler, onRemove, index) {

    const editorActionButtonProperties = {
      ...action
    };

    if (typeof action.onClick !== 'function') {
      editorActionButtonProperties.onClick = groupClickHandler;
      editorActionButtonProperties.onRemove = onRemove;
    }

    if (action.buttonType === 'file') {
      editorActionButtonProperties.onFile = action.onFile;
      return <FileUploadActionButton {...editorActionButtonProperties} />;
    }

    if (action.expandable === true) {
      return <ExpandableEditorActionButton key={index} {...editorActionButtonProperties} />;
    }

    return <EditorActionButton key={index} {...editorActionButtonProperties} />;
  }

  function renderEditorActionButtons(actions, onClick, onRemove) {

    const editorActionButtonsDataCount = actions.length;
    const elements = [];

    for (let index = 0; index < editorActionButtonsDataCount; index++) {

      const element = renderEditorActionButton(actions[index], onClick, onRemove, index);
      elements.push(element);

    }

    return <ul className="editor-action-buttons-list helptap-list">
      {elements}
    </ul>;

  }

  function renderGroup(group, index) {

    return <div className="editor-action-group" key={index}>
      <label className='editor-actions-heading'>{group.name}</label>

      {renderEditorActionButtons(group.actions, group.onClick, group.onRemove)}
    </div>;

  }

  function renderGroups() {

    const actionGroups = props.actionGroups;
    const groupsLength = actionGroups.length;
    const elements = [];

    for (let index = 0; index < groupsLength; index++) {

      const group = actionGroups[index];

      if (group.actions.length === 0) {
        continue;
      }

      elements.push(renderGroup(group, index));

    }

    return elements;

  }

  function renderMain() {

    return <div className='editor-actions-main hide-scrollbar'>

      {renderGroups()}

    </div>;

  }

  return renderMain();

}

export default EditorActions;